// Minimal markdown -> HTML for Thomas replies (bold, code, links, headings, lists, severity chips).
// Text is escaped first and the result is bound via [innerHTML] under Angular's sanitiser.
export function thomasMarkdown(text: string): string {
  const escape = (s: string) => s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
  const inline = (s: string) => s
    .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
    .replace(/`([^`]+)`/g, '<code>$1</code>')
    .replace(/\[([^[\]]+)\]\(((?:https?:\/\/|mailto:)(?:[^\s()]|\([^\s()]*\))+)\)/g, '<a href="$2" target="_blank" rel="noopener">$1</a>');
  const withSeverity = (s: string) => {
    const m = /^\**(high|medium|low)\**\s*[:\-–—]\**\s*(.*)$/i.exec(s);
    if (!m) {
      return inline(s);
    }
    return `<span class="sev sev-${m[1].toLowerCase()}">${m[1].toUpperCase()}</span> ` + inline(m[2]);
  };

  const html: string[] = [];
  let inOl = false;
  let liOpen = false;
  let inNestedUl = false;
  let inUl = false;
  let blankBefore = false;

  const closeLi = () => {
    if (inNestedUl) {
      html.push('</ul>');
      inNestedUl = false;
    }
    if (liOpen) {
      html.push('</li>');
      liOpen = false;
    }
  };
  const closeAll = () => {
    closeLi();
    if (inOl) {
      html.push('</ol>');
      inOl = false;
    }
    if (inUl) {
      html.push('</ul>');
      inUl = false;
    }
  };

  text.split('\n').forEach(raw => {
    const line = escape(raw.trimEnd());
    const trimmed = line.trim();
    if (!trimmed) {
      blankBefore = true; // blank lines never break a list
      return;
    }
    const indented = /^\s/.test(raw);
    const continuesItem = inOl && liOpen && (indented || !blankBefore);
    blankBefore = false;
    const bullet = /^\s*[-*•]\s+(.*)$/.exec(line);
    const numbered = /^\s*\d+[.)]\s+(.*)$/.exec(line);
    const heading = /^#{1,6}\s+(.*)$/.exec(trimmed);
    const sectionLabel = /^(?:\*\*)?([A-Za-z][A-Za-z0-9 '&/-]{0,40}):(?:\*\*)?$/.exec(trimmed);

    if (numbered) {
      closeLi();
      if (inUl) {
        html.push('</ul>');
        inUl = false;
      }
      if (!inOl) {
        html.push('<ol>');
        inOl = true;
      }
      html.push('<li>' + inline(numbered[1]));
      liOpen = true;
    } else if (bullet) {
      if (inOl && liOpen) {
        if (!inNestedUl) {
          html.push('<ul>');
          inNestedUl = true;
        }
      } else {
        if (inOl) {
          html.push('</ol>');
          inOl = false;
        }
        if (!inUl) {
          html.push('<ul>');
          inUl = true;
        }
      }
      html.push('<li>' + withSeverity(bullet[1]) + '</li>');
    } else if (heading || (sectionLabel && !(continuesItem && indented))) {
      closeAll();
      html.push('<h4>' + inline((heading ?? sectionLabel)![1]) + '</h4>');
    } else if (continuesItem) {
      if (inNestedUl) {
        html.push('</ul>');
        inNestedUl = false;
      }
      html.push(sectionLabel ? '<h4>' + inline(sectionLabel[1]) + '</h4>' : '<p>' + inline(trimmed) + '</p>');
    } else {
      closeAll();
      html.push('<p>' + inline(trimmed) + '</p>');
    }
  });
  closeAll();
  return html.join('');
}
